export function prefersReducedMotion() {
  return (
    typeof window.matchMedia === "function" &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches
  );
}

export function scrollToSection(id, behavior = "smooth") {
  const el = document.getElementById(id);
  if (!el) return;
  el.scrollIntoView({
    behavior: prefersReducedMotion() ? "auto" : behavior,
    block: "start",
  });
}

export function scrollToTop(behavior = "smooth") {
  window.scrollTo({
    top: 0,
    behavior: prefersReducedMotion() ? "auto" : behavior,
  });
}
